
<script context="module">

  export const H1 = Symbol('h1');
  export const H2 = Symbol('h2');
  export const H3 = Symbol('h3');

</script>

<script>
  export let tag;
</script>

{#if tag === H1}
  <h1 class="title-h1"><slot></slot></h1>
{:else if tag === H2}
  <h2 class="title-h2"><slot></slot></h2>
{:else if tag === H3}
  <h3 class="title-h3"><slot></slot></h3>
{:else}
  Invalid tag '{tag}'
{/if}

<style>
  .title-h1 {
    --marginBottom: 24px;
    margin-bottom: var(--marginBottom);
    font-family: var(--title-h1--fontFamily);
    font-size: var(--title-h1--fontSize, 48px);
    font-weight: var(--title-h1--fontWeight, 700);
    line-height: 1.1;
  }

  .title-h2 {
    --marginBottom: 16px;
    margin-bottom: var(--marginBottom);
    font-family: var(--title-h2--fontFamily);
    font-size: var(--title-h2--fontSize, 32px);
    font-weight: var(--title-h2--fontWeight, 700);
    line-height: 1.1;
  }

  .title-h3 {
    --marginBottom: 16px;
    margin-bottom: var(--marginBottom);
    font-family: var(--title-h3--fontFamily);
    font-size: var(--title-h3--fontSize, 32px);
    font-weight: var(--title-h3--fontWeight, 400);
    line-height: 1.1;
  }
</style>
